import { skipToken } from "@reduxjs/toolkit/query";
import { useState } from "react";
import { useOutletContext } from "react-router-dom";
import CustomerContextMenu from "../../components/customer-list/components/CustomerContextMenu";
import CustomerListBase from "../../components/customer-list/components/CustomerListBase";
import useGetCompanyMarkingNr from "../../hooks/useGetCompanyMarkingNr";
import {
  Customer,
  MyCustomerApiResponse,
  useGetCustomerGroupCustomersQuery,
} from "../../store/services/customerService";

interface CustomerOutletContext {
  customer: Customer;
}

const CustomerGroupsPage = () => {
  const { customer } = useOutletContext<CustomerOutletContext>();
  const markingsGroupNr = useGetCompanyMarkingNr();
  const customerGroupId = customer.CustomerGroups.find(
    (x) => x.Id === markingsGroupNr
  )?.SelectedValue;
  const {
    data: customers = [],
    error,
    isLoading,
    isFetching,
  } = useGetCustomerGroupCustomersQuery(
    customerGroupId ? Number(customerGroupId) : skipToken
  );
  // State for context menu and dialogs
  const [contextMenu, setContextMenu] = useState<{
    mouseX: number;
    mouseY: number;
    customer: MyCustomerApiResponse;
  } | null>(null);

  // Handle context menu for My Customers view
  const handleContextMenu = (
    customer: MyCustomerApiResponse,
    event: React.MouseEvent
  ) => {
    event.preventDefault();
    setContextMenu({
      mouseX: event.clientX,
      mouseY: event.clientY,
      customer,
    });
  };

  // Close context menu
  const handleCloseContextMenu = () => {
    setContextMenu(null);
  };

  const handleCustomerAction = () => {
    const customer = contextMenu?.customer;
    if (!customer) return;

    /*     switch (action) {
      case "viewDetails":
        // Navigate to details
        navigate(`/customer/${customer.Id}`);
        break;
      case "copyId":
        navigator.clipboard.writeText(customer.CustomerId);
        break;
      case "copyName":
        navigator.clipboard.writeText(customer.Name);
        break;
      // Other actions are handled by the CustomerContextMenu component itself
    } */

    handleCloseContextMenu();
  };

  return (
    <>
      <CustomerListBase
        customers={customers}
        isLoading={isLoading}
        isFetching={isFetching}
        error={error}
        renderContextMenu={handleContextMenu}
      />
      <CustomerContextMenu
        contextMenu={contextMenu}
        onClose={handleCloseContextMenu}
        onAction={handleCustomerAction}
      />
    </>
  );
};

export default CustomerGroupsPage;
